import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { NOMINEES, type FeedbackSpaceConfig, type FeedbackSpaceErrors } from './feedbackSpaceConfig'

interface Props {
  config: FeedbackSpaceConfig
  onChange: (config: FeedbackSpaceConfig) => void
  errors?: FeedbackSpaceErrors
  disabled?: boolean
}

/**
 * The Feedbacks space's own setting (extension 2): how many colleagues a
 * leader nominates in one request about a person. One component for the
 * creation wizard and the space edit (PADROES-UI section 14); empty goes
 * back to the default.
 */
export const FeedbackSpaceFields = ({ config, onChange, errors, disabled }: Props) => {
  const { t } = useTranslation('feedbacks')
  return (
    <div className="min-w-0 space-y-2" data-testid="feedback-space-settings">
      <label htmlFor="feedback-max-nominees" className="text-sm font-medium text-gray-700">{t('about.settings.label')}</label>
      <Input id="feedback-max-nominees" type="number" inputMode="numeric" min={NOMINEES.min} max={NOMINEES.max} step={1}
        className="w-28" value={config?.maxNominees ?? ''} disabled={disabled} placeholder={String(NOMINEES.default)}
        onChange={(e) => onChange({ ...config, maxNominees: e.target.value })} />
      <p className="text-xs text-gray-500">{t('about.settings.hint', { min: NOMINEES.min, max: NOMINEES.max, def: NOMINEES.default })}</p>
      {errors?.maxNominees && <p role="alert" className="text-sm text-red-600">{errors.maxNominees}</p>}
    </div>
  )
}
